export const locale = {
    lang: 'fr',
    data: {
        TRANSFORM_EXPORT: 'Exporter cartes vers une autre activité',
        SELECTION: 'Sélection',
        ACTIVITY: 'Activité',
    }
};
